import {
  SET_BUSINESS_EVENTS,
  SET_OFFERS_ELIGIBILITY,
  SET_OFFERS_ELIGIBILITY_FETCHED,
} from '@monolith/legacy/store/offers/mutation-types';
import { OffersState } from '@monolith/legacy/store/offers/index';
import { BusinessEventPeriode } from '@monolith/legacy/types/business-event';
import { OfferProgramEligibility } from '@monolith/legacy/modules/promote-engage/services/offer';

const offersMutations = {
  [SET_BUSINESS_EVENTS]: (state: OffersState, value: BusinessEventPeriode[]): void => {
    state.events = [...value];
  },
  [SET_OFFERS_ELIGIBILITY]: (state: OffersState, value: OfferProgramEligibility[]): void => {
    if (value) {
      state.offerEligibility.eligibility = [...value];
    }
  },
  [SET_OFFERS_ELIGIBILITY_FETCHED]: (state: OffersState): void => {
    state.offerEligibility.eligibilityFetched = true;
  },
};

export default offersMutations;
export type OffersMutations = typeof offersMutations;
